import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Text } from '@chakra-ui/react';

import { Container } from './Container';
import { TabsMenu } from './TabsMenu';

interface NameLiProps {
  onClick?: (index: number) => void;
  index: number;
  handleCloseModal?: () => void;
  isActive: boolean;
  tabName: string;
  disabled: boolean;
}

class NameLi extends React.Component<NameLiProps> {
  handleClick = () => {
    const { onClick, index, handleCloseModal } = this.props;
    handleCloseModal && handleCloseModal();
    onClick && onClick(index);
  };

  render() {
    const { isActive, tabName, disabled } = this.props;
    return (
      <li
        className={classNames({ active: isActive, disabled })}
        onClick={this.handleClick}
      >
        <Text as="div" textStyle="caption" className="caption">
          {tabName}
        </Text>
      </li>
    );
  }
}

interface TabsProps {
  tabNames: any[];
  disabledIndexes?: number[];
  activeIndex: number;
  onClick: (index: number) => void;
  style?: any;
}

export class Tabs extends React.Component<TabsProps> {
  render() {
    const { tabNames, disabledIndexes = [], activeIndex, onClick } = this.props;
    const moduloActiveIndex = Math.abs(activeIndex % tabNames.length);
    return (
      <Container>
        <ul className="hide-phone">
          {tabNames.map((tabName, i) => (
            <NameLi
              key={i}
              tabName={tabName}
              disabled={disabledIndexes.includes(i)}
              isActive={i === moduloActiveIndex}
              index={i}
              onClick={!disabledIndexes.includes(i) ? onClick : undefined}
            />
          ))}
        </ul>
        <TabsMenu
          className="show-phone"
          activeIndex={moduloActiveIndex}
          activeTab={tabNames[moduloActiveIndex]!}
          disabledIndexes={disabledIndexes}
          tabs={tabNames}
          onClick={onClick}
        />
      </Container>
    );
  }
}
